const o = 1e3, n = 6e4, t = 36e5, a = 864e5, r = 6048e5, u = 2592e6, d = 31536e6;
export {
  a as durationDay,
  t as durationHour,
  n as durationMinute,
  u as durationMonth,
  o as durationSecond,
  r as durationWeek,
  d as durationYear
};
